/**
 * encode
 * @param  {string} value
 * @return {string}
 */
__.encode = function(value) {
  return encodeURIComponent(value);
};
